import { render, staticRenderFns } from "./AlertAuditLog.vue?vue&type=template&id=68c81d70&"
import script from "./AlertAuditLog.vue?vue&type=script&lang=ts&"
export * from "./AlertAuditLog.vue?vue&type=script&lang=ts&"
import style0 from "./AlertAuditLog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports